module.exports = __webpack_public_path__ + "hat-classic-granite.c7384fce53dd8a83f826.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/hat-classic-granite.svg
// module id = ../../../../../src/assets/img/hat-classic-granite.svg
// module chunks = main